export default ['5115003', '1010101', '3010228', '3010220', '5115004', 'TG22011']